"use client";

import { useState } from "react";

import styles from "./DevelopmentIndicator.module.css";

const developmentBranch = process.env.NEXT_PUBLIC_DEV_BRANCH;

const PALETTES = [
  {
    text: "#6ee7b7",
    dot: "#34d399",
    border: "rgba(52,211,153,0.3)",
    bg: "rgba(6,20,15,0.85)",
  },
  {
    text: "#93c5fd",
    dot: "#60a5fa",
    border: "rgba(96,165,250,0.3)",
    bg: "rgba(6,12,20,0.85)",
  },
  {
    text: "#fca5a5",
    dot: "#f87171",
    border: "rgba(248,113,113,0.3)",
    bg: "rgba(20,6,6,0.85)",
  },
  {
    text: "#fcd34d",
    dot: "#fbbf24",
    border: "rgba(251,191,36,0.3)",
    bg: "rgba(20,16,4,0.85)",
  },
  {
    text: "#c4b5fd",
    dot: "#a78bfa",
    border: "rgba(167,139,250,0.3)",
    bg: "rgba(12,6,20,0.85)",
  },
  {
    text: "#fdba74",
    dot: "#fb923c",
    border: "rgba(251,146,60,0.3)",
    bg: "rgba(20,10,4,0.85)",
  },
] as const;

function hashBranch(branch: string): number {
  let hash = 0;
  for (let index = 0; index < branch.length; index++) {
    hash = (hash * 31 + (branch.codePointAt(index) ?? 0)) & 0xff_ff;
  }
  return hash;
}

export function DevelopmentIndicator() {
  const [dismissed, setDismissed] = useState(false);

  // eslint-disable-next-line unicorn/no-null -- React components return null to render nothing
  if (dismissed) return null;

  const label = developmentBranch || "dev";
  const palette = PALETTES[hashBranch(label) % PALETTES.length];

  return (
    <button
      type="button"
      onClick={() => setDismissed(true)}
      title="Click to dismiss"
      aria-label={`Dev build on branch ${label} — click to dismiss`}
      className={styles.pill}
      style={{
        color: palette.text,
        borderColor: palette.border,
        background: palette.bg,
      }}
    >
      <span className={styles.dot} style={{ background: palette.dot }} />
      <span className={styles.label}>{label}</span>
    </button>
  );
}
